import {
  ProjectInterface as IProject,
  SyncAction,
} from "../../models/interfaces/project.interface";

import { AppState } from "../../states/app-state.interface";
import { AddressInterface as IAddress } from "../../models/interfaces/projectFormAreaCreate/parts/address.interface";
import { Injectable } from "@angular/core";
import { Project } from "../../models/project.model";
import { ProjectProvider } from "../../providers/project/project";
import { ProjectsActions } from "../../states/v2/projects";
import { Store } from "@ngrx/store";

@Injectable()
export class ProjectsRepository {
  public projects$ = this.s.select((s) =>
    s.projects_v2.projects.filter((proj) => !proj.archived)
  );
  public archivedProjects$ = this.s.select((s) =>
    s.projects_v2.projects.filter((proj) => proj.archived)
  );
  public activeProject$ = this.s.select(
    (s) => s.projects_v2.projects[s.projects_v2.activeProjectIndex]
  );
  public changedProjects$ = this.s.select((s) =>
    s.projects_v2.projects.filter((project) => project.dirty)
  );

  constructor(
    private s: Store<AppState>,
    private projectsActions: ProjectsActions,
    private projectProvider: ProjectProvider
  ) {}

  public getAll() {
    return this.projectProvider
      .getSavedProjects()
      .map((res: { active: {}[]; archive: {}[] }) => {
        // Process active projects
        let activeProjects: IProject[] = [];
        for (let project of res.active) {
          activeProjects.push(Project.formatResponse(project));
        }

        // Process archived projects
        let archivedProjects: IProject[] = [];
        for (let project of res.archive) {
          archivedProjects.push(Project.formatResponse(project));
        }

        // Mutate in store
        this.s.dispatch(
          this.projectsActions.set({
            projects: [...archivedProjects, ...activeProjects],
          })
        );
      });
  }

  public getActive() {
    return this.projectProvider.getProjects(false).map((res: {}[]) => {
      res.forEach((project) => {
        this.s.dispatch(
          this.projectsActions.addOrUpdate({
            project: Project.formatResponse(project),
          })
        );
      });
    });
  }

  public getArchived() {
    return this.projectProvider.getProjects(true).map((res: {}[]) => {
      res.forEach((project) => {
        this.s.dispatch(
          this.projectsActions.addOrUpdate({
            project: Project.formatResponse(project),
          })
        );
      });
    });
  }

  public add(project: Project) {
    this.s.dispatch(this.projectsActions.add({ project }));
  }

  public saveProjectStep(step: string, fields: object, valid: boolean = true) {
    this.s.dispatch(
      this.projectsActions.saveProjectStep({ step, fields, valid })
    );

    return this.activeProject$;
  }

  public updateActiveProject(project: IProject) {
    this.s.dispatch(
      this.projectsActions.updateActiveProject({ project: project })
    );
  }

  public changeActiveProject(project: IProject) {
    this.s.dispatch(
      this.projectsActions.changeActiveProject({ project: project })
    );
  }

  public syncProject(project: IProject) {
    if (project.archived) {
      this.s.dispatch(
        this.projectsActions.archiveProject({ project: project })
      );
    }
    if (!project.archived) {
      this.s.dispatch(
        this.projectsActions.restoreProject({ project: project })
      );
    }

    return this.projectProvider.syncProject(project).map((data: any) => {
      this.s.dispatch(
        this.projectsActions.setLastSyncedAt({
          project,
          lastSyncedAt: data.project.last_synced_at,
        })
      );
      return data;
    });
  }

  public setAddresses(addresses: IAddress[]) {
    this.s.dispatch(
      this.projectsActions.setAddresses({ addresses: addresses })
    );
  }

  public uploadAddresses(project: IProject, file: File) {
    return this.projectProvider.uploadAddresses(project, file);
  }

  public remove(id) {
    return this.projectProvider.delete(id);
  }

  public setSyncAction(project: IProject, action: SyncAction) {
    this.s.dispatch(this.projectsActions.setSyncAction({ project, action }));
  }

  public getSyncStatus(project: IProject) {
    return this.projectProvider.syncStatus(project);
  }
}



// WEBPACK FOOTER //
// ./src/repositories/v2/projects.repository.ts